import {
    SYSTEM_CHOOSE_CURRENT_POSITIONTYPE,
} from './constants';
  
export function chooseCurrentPositionType(modal) {
    return {
      type: SYSTEM_CHOOSE_CURRENT_POSITIONTYPE,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_CHOOSE_CURRENT_POSITIONTYPE:
        return {
          ...state,
          currentPositionType:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/system/redux/chooseCurrentPositionType.js